import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClose", "task"];
import { useEffect } from 'react';
import { ManualDetectedTaskComponents } from './ManualDetectedTaskComponents';
import { useHandholdingBannerHelpers } from '../../../hooks/addonComponents';
import { jsx as _jsx } from "react/jsx-runtime";
const ManualDetectedTaskComponent = _ref => {
  let {
      onClose,
      task
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const TaskComponent = ManualDetectedTaskComponents[task.key];
  const {
    closeHandholdingBanner,
    loadHandholdingBanner
  } = useHandholdingBannerHelpers();
  useEffect(() => {
    if (TaskComponent && typeof loadHandholdingBanner === 'function') {
      loadHandholdingBanner(task.id, task.handholdingGroupKeyOverride);
    }
  }, [loadHandholdingBanner, task.id, task.handholdingGroupKeyOverride, TaskComponent]);
  if (!TaskComponent) {
    return null;
  }
  return /*#__PURE__*/_jsx(TaskComponent, Object.assign({
    onClose: () => {
      if (typeof onClose === 'function') {
        onClose();
      }
      if (typeof closeHandholdingBanner === 'function') {
        closeHandholdingBanner();
      }
    }
  }, props));
};
export default ManualDetectedTaskComponent;